import * as React from 'react'

import { Strong, Text } from 'main/ui'
import PaySchedule from 'main/ui/icons/PaySchedule'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-PAYMENT-SCHEDULES`

interface IProps {
  weeklyBillingAccepted: boolean
}

export default function PaymentSchedules({ weeklyBillingAccepted }: IProps) {
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Bullet icon={<PaySchedule />}>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      <Text muted>
        {weeklyBillingAccepted ? t(`${PRE}-MONTHLY-OR-WEEKLY`) : t(`${PRE}-MONTHLY`)}
      </Text>
    </Bullet>
  )
}
